import axios from 'axios';
import { BASE_API, USER_TOKEN } from 'config/consts';

const URL = `${BASE_API}/station-subscriptions-dash`;
const URL_PRODUCTS_ORDERS = `${BASE_API}/product-orders-by-station`;
const URL_PAYMENT_LINKS = `${BASE_API}/payment-links/station`;
const PAGAMENTO_CONFIRMADO = 'Pagamento confirmado';

const normalizeProductOrders = (orders = []) => {
  return orders.flatMap((order) => {
    return (order.single_product_orders || []).map((spo) => {
      return {
        id: order.id,
        purchase_id: order.purchase_id,
        code: order.code,
        createdAt: order.createdAt,
        user: order.user,
        product: spo.product,
        validated: order.validated,
        validationDate: order.validation_date,
        action: order.action,
        status: order.status,
        gateway_charge: order.gateway_charge,
        saleSource: 'product_order',
        voucherApplicable: true,
      };
    });
  });
};

const normalizePaymentLinks = (links = [], stationId) => {
  return links.map((link) => {
    const serviceName = link.service || link.activity || 'Link de Pagamento';
    const paymentMethod = link.paymentMethod || null;
    const isPaid = link.status === 'paid';
    const recurrenceType = link.recurrence_type || 'single';

    return {
      id: link.linkId || link.id,
      purchase_id: link.id,
      code: link.id,
      createdAt: link.createdAt,
      user: {
        name: link.name,
        cpf: link.cpf,
      },
      product: {
        id: `payment-link-${serviceName}`,
        name: serviceName,
        value: link.grossValue ?? link.value ?? 0,
        discount_value: 0,
        stock: 0,
      },
      validated: null,
      validationDate: null,
      action: {
        id: `payment-link-action-${serviceName}`,
        name: link.activity || serviceName,
        station: {
          id: stationId,
          name: null,
        },
        partner: link.partner || null,
      },
      status: isPaid ? PAGAMENTO_CONFIRMADO : link.status,
      gateway_charge: {
        payment_method: paymentMethod,
      },
      saleSource: 'payment_link',
      voucherApplicable: false,
      paymentLinkStatus: link.status,
      hasPartner: !!link.partner,
      netValue: link.netValue,
      fee: link.fee,
      recurrence_type: recurrenceType,
      isRecurringPaymentLink: recurrenceType !== 'single',
    };
  });
};

export const getList = (id) => {
  return (dispatch) => {
    dispatch({ type: 'FINANCIAL_DASHBOARD_LOAD', payload: true, loading: true });
    axios
      .get(`${URL}/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: 'FINANCIAL_DASHBOARD_FETCHED',
            payload: response,
            loading: false,
          },
        ]);
      })
      .catch((error) => {
        console.error('Erro ao buscar dados do dashboard:', error?.message);
        dispatch({
          type: 'FINANCIAL_DASHBOARD_FETCHED',
          payload: { data: [] },
          loading: false,
        });
      });
  };
};

export const getListProductsOrders = (stationId) => {
  return async (dispatch) => {
    dispatch({ type: 'FINANCIAL_DASHBOARD_LOAD', payload: true, loading: true });
    try {
      const headers = {
        Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
      };

      const [productOrdersResponse, paymentLinksResponse] = await Promise.all([
        axios.get(`${URL_PRODUCTS_ORDERS}/${stationId}`, { headers }),
        axios.get(`${URL_PAYMENT_LINKS}/${stationId}`, { headers }),
      ]);

      const normalizedProductOrders = normalizeProductOrders(productOrdersResponse.data || []);
      const normalizedPaymentLinks = normalizePaymentLinks(
        paymentLinksResponse.data?.list || [],
        stationId
      );

      dispatch([
        {
          type: 'FINANCIAL_DASHBOARD_PRODUCTS_ORDERS_FETCHED',
          payload: [...normalizedProductOrders, ...normalizedPaymentLinks].sort(
            (itemA, itemB) => new Date(itemB.createdAt || 0) - new Date(itemA.createdAt || 0)
          ),
          loading: false,
        },
      ]);
    } catch (_error) {
      dispatch({ type: 'FINANCIAL_DASHBOARD_LOAD', payload: false, loading: false });
    }
  };
};

export const getAllDashboardData = (stationId) => {
  return async (dispatch) => {
    dispatch({ type: 'FINANCIAL_DASHBOARD_LOAD', payload: true, loading: true });
    try {
      const headers = {
        Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
      };

      const [vouchersResponse, productOrdersResponse, paymentLinksResponse] = await Promise.all([
        axios.get(`${URL}/${stationId}`, { headers }),
        axios.get(`${URL_PRODUCTS_ORDERS}/${stationId}`, { headers }),
        axios.get(`${URL_PAYMENT_LINKS}/${stationId}`, { headers }),
      ]);

      const normalizedProductOrders = normalizeProductOrders(productOrdersResponse.data || []);
      const normalizedPaymentLinks = normalizePaymentLinks(
        paymentLinksResponse.data?.list || [],
        stationId
      );

      dispatch({
        type: 'FINANCIAL_DASHBOARD_FETCHED',
        payload: vouchersResponse,
        loading: false,
      });

      dispatch({
        type: 'FINANCIAL_DASHBOARD_PRODUCTS_ORDERS_FETCHED',
        payload: [...normalizedProductOrders, ...normalizedPaymentLinks].sort(
          (itemA, itemB) => new Date(itemB.createdAt || 0) - new Date(itemA.createdAt || 0)
        ),
        loading: false,
      });
    } catch (error) {
      console.error('Erro ao carregar dados do dashboard:', error?.message);
      dispatch({ type: 'FINANCIAL_DASHBOARD_LOAD', payload: false, loading: false });
    }
  };
};
